import { render } from "./PaymentProviderContent.vue?vue&type=template&id=25dd41df"
import script from "./PaymentProviderContent.vue?vue&type=script&lang=js"
export * from "./PaymentProviderContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__